import * as React from 'react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import hasFeature from 'modules/core/lib/hasFeature'
import companies from 'modules/core/store/collections/companies'

import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'
import authService, { Status as AuthStatus } from 'modules/integrations_silae_api/lib/authService'
import Relink from 'modules/payroll_integrations_kombo/components/SupplementsSyncPreview/Relink'
import CompanyInstallationsChecker from 'modules/payroll_integrations_kombo/lib/CompanyInstallations/checker'
import { IntegrationLabels } from 'modules/payroll_integrations_kombo/lib/constants'

import SupplementsToSync from './SupplementsToSync'

interface Props {
  policyPeriodId: number
  disableSubmitCallback: (value: boolean) => void
}

const SupplementsSyncPreview = ({ policyPeriodId, disableSubmitCallback }: Props) => {
  const [blockedSubmit, setBlockedSubmit] = React.useState<boolean>(true)
  const [authStatus, setAuthStatus] = React.useState<AuthStatus>(AuthStatus.NotAvailable)
  const companyId = companies.current.id
  const isBookkeeperView = useBookkeeperView()

  const fetchAuthStatus = async () => {
    const currentAuthStatus = await authService.getStatus({
      companyId: companyId,
      bookkeeperView: isBookkeeperView,
    })
    if (currentAuthStatus != AuthStatus.AuthenticationExpired) {
      setBlockedSubmit(false)
      disableSubmitCallback(false)
    }
    setAuthStatus(currentAuthStatus)
  }

  const connect = async () => {
    await authService.connect(authStatus, companyId)
    fetchAuthStatus()
  }

  const { loading } = useAsyncData(async () => {
    if (!hasFeature('dev_silae_api_supplements')) return
    const installed = await CompanyInstallationsChecker.isSilaeApiInstalled()
    if (!installed) return

    disableSubmitCallback(true)
    fetchAuthStatus()
  }, [policyPeriodId])

  const show = !loading && authStatus !== AuthStatus.NotAvailable

  if (!show) return <></>

  return (
    <>
      {authStatus == AuthStatus.Authenticated ? (
        <SupplementsToSync policyPeriodId={policyPeriodId}></SupplementsToSync>
      ) : (
        <Relink
          onClick={connect}
          blockedSubmit={blockedSubmit}
          integrationLabel={IntegrationLabels.silae}
        />
      )}
    </>
  )
}

export default SupplementsSyncPreview
